import { Modal } from '@magickainteractive/modals';

export function showConfirm(title, message, confirmLabel = 'Confirm') {
    return new Promise((resolve) => {
        const modal = new Modal({
            title,
            content: `<p class="confirm-message">${message}</p>`,
            actions: [
                {
                    label: 'Cancel',
                    color: '#6b7280',
                    action: () => {
                        modal.close();
                        resolve(false);
                    },
                },
                {
                    label: confirmLabel,
                    color: '#00644c',
                    action: () => {
                        modal.close();
                        resolve(true);
                    },
                },
            ],
        });
        modal.open();
    });
}
